<template>
  <div>
    <v-snackbar v-model="showAlert" :top="true" color="error">{{errorMessage}}</v-snackbar>

    <v-form v-if="!sent">
      <v-card>
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <span class="headline">Zabudnuté heslo</span>
            </v-flex>
            <v-flex xs12>
              <span>Zadajte svoj prihlasovací email</span>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-validate="'required|email'"
            data-vv-as="Email"
            :error-messages="errors.collect('forgotEmail')"
            prepend-icon="email"
            name="forgotEmail"
            label="Email"
            type="email"
            v-model="forgotPassword.email"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="authStatus == 'loading'"
            :disabled="authStatus == 'loading'"
            color="primary"
            @click.prevent="submit"
          >
            <span>Odoslať</span>
            <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-card v-else>
      <v-card-text>
        <v-layout justify-center class="pa-4">
          <v-icon x-large color="success">thumb_up</v-icon>
        </v-layout>

        <v-alert :value="true" color="success" icon="check_circle" outline>
          <span>Vaša požiadavka bola úspešne spracovaná.</span>
        </v-alert>
        <v-alert :value="true" color="info" icon="info" outline>
          <span>
            Prosím skontrolujte svoj email
            <i>{{forgotPassword.email}}</i> a potvrte reset hesla.
          </span>
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as types from "@/store/types";
export default {
  data() {
    return {
      showAlert: false,
      showAlertTimout: 3000,
      errorMessage: "Skontrolujte svoj mail",
      sent: false,
      forgotPassword: {
        email: ""
      }
    };
  },
  computed: {
    authStatus() {
      return this.$store.getters.authStatus;
    }
  },
  methods: {
    submit: function() {
      this.$validator.validate().then(result => {
        if (result) {
          const vm = this;
          const payload = {
            Email: this.forgotPassword.email
          };
          this.$store
            .dispatch(types.AUTH_FORGOT_PASSWORD, payload)
            .then(() => {
              // this.$router.push({ path: '/resetPassword' })
              vm.sent = true;
              console.log("forgot password");
            })
            .catch(e => {
              vm.showAlert = true;
              console.error(e);
            });
        }
      });
    }
  }
};
</script>
<style>
</style>